import * as Variations from './Variations'
import { HtmlBuilder } from './HtmlBuilder'
import { HeadingFactory } from '../../factories/HeadingFactory'
import { EditorComponentContract } from '../EditorComponentContract'
export class Heading extends EditorComponentContract {
  constructor() {
    super(Variations)
    this.htmlBuilder = HtmlBuilder
    this.factory = new HeadingFactory
  }

  elementIds() {
    return ['id']
  }

  elementClasses() {
    return ['classes']
  }

  elementContents() {
    return ['text']
  }

  elementStyles() {
    return [
      {id: 'id', element: 'id', styles: 'styles', selector: '#', variation: null},
    ]
  }

  info() {
    return {
      name: 'Heading',
      icon: 'fa-heading',
      variations: this.variationsInfo()
    }
  }
}